import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../Styles/AboutUs.css';
import missionImage from '../../Assets/logo_rm.png';
import NavBar from '../NavBar';

const AboutUs = () => {
  const navigate = useNavigate();

  /* REMOVED handleBackToHome */
  const handleViewBoardMembers = () => {
    navigate('/board-members');
  };

  return (

    <div className="about-us-container">
      <NavBar />
      <main className="about-us-main">
        {/* Hero Section */}
        <section className="about-hero-section">
          <div className="container">
            <h1 className="about-hero-title">About TechStrike</h1>

            <button className="btn-secondary view-board-btn" onClick={handleViewBoardMembers}>
              View Board Members 25/26 →
            </button>
          </div>
        </section>

        {/* Mission Section */}
        <section className="mission-section">
          <div className="container">
            <div className="mission-content">
              <div className="mission-text">
                <h2 id="mission">Mission</h2>
                <div className="mission-highlight">
                  <p className="mission-statement">
                    The mission of the Techstrike Club is to empower students with practical technology skills, encourage innovation, and promote teamwork through hands-on projects, workshops, and competitions. We aim to create a professional and supportive environment where students can learn, grow, and prepare for successful careers in the technology industry.
                  </p>
                </div>
                <p>
                  At TechStrike, greatness begins with curiosity and grows through collaboration.
                  We create an inspiring ecosystem where technology meets creativity, gaming passion
                  fuels innovation, and every member discovers their potential to shape the digital future.
                </p>
                <p>
                  Techstrike Club is the main IT club of CINEC Campus, dedicated to developing skilled, confident, and innovative technology professionals. Through practical projects, industry-focused workshops, and collaborative learning, we provide students with the knowledge and experience needed to lead and shape the future of information technology.
                </p>
              </div>
              <div className="mission-image">
                <div className="mission-placeholder">
                  <img src={missionImage} alt="TechStrike Mission" className="mission-img" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="values-section">
          <div className="container">
            <h2 id='mission'>Our Core Values</h2>
            <div className="values-grid">
              <div className="value-card">
                <div className="value-icon">💡</div>
                <h3>Innovation</h3>
                <p>We encourage creative thinking and innovative solutions to technological challenges.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">🤝</div>
                <h3>Collaboration</h3>
                <p>We believe in the power of teamwork and collective problem-solving.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">📚</div>
                <h3>Learning</h3>
                <p>We promote continuous learning and skill development in emerging technologies.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">🌟</div>
                <h3>Excellence</h3>
                <p>We strive for excellence in everything we do, from events to educational content.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Join Section */}
        <section className="join-section">
          <div className="container">
            <div className="join-content">
              <h2 id='mission'>Ready to Join Our Community?</h2>
              <p>
                Become part of TechStrike and connect with like-minded individuals who share
                your passion for technology and innovation.
              </p>
              <div className="join-benefits">
                <div className="benefit">
                  <span className="benefit-icon"></span>
                  <span>Graphic Design</span>
                </div>
                <div className="benefit">
                  <span className="benefit-icon"></span>
                  <span>E-sport</span>
                </div>
                <div className="benefit">
                  <span className="benefit-icon"></span>
                  <span>Public Relations</span>
                </div>
                <div className="benefit">
                  <span className="benefit-icon"></span>
                  <span>Professional Development</span>
                </div>
                <div className="benefit">
                  <span className="benefit-icon"></span>
                  <span>Entrepreneurship and Industrial Relations</span>
                </div>
                <div className="benefit">
                  <span className="benefit-icon"></span>
                  <span>Club Services</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default AboutUs;
